import { useState, useRef } from "react";

const usePDFOperations = () => {
  const [pdfFile, setPdfFile] = useState(null);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [numPages, setNumPages] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [scale, setScale] = useState(1.5);
  const [signaturePositions, setSignaturePositions] = useState([]);
  const [isSelectingPosition, setIsSelectingPosition] = useState(false);
  const containerRef = useRef(null);
  const [cursorPosition, setCursorPosition] = useState({ x: 0, y: 0 });

  const handlePdfClick = (e) => {
    if (!isSelectingPosition) return;

    const container = containerRef.current;
    const pdfElement = container.querySelector(".react-pdf__Page");
    if (!pdfElement) return;

    const pdfRect = pdfElement.getBoundingClientRect();
    const scrollLeft = container.scrollLeft || 0;
    const scrollTop = container.scrollTop || 0;

    const normalizedX = (e.clientX + scrollLeft - pdfRect.left) / pdfRect.width;
    const normalizedY = (e.clientY + scrollTop - pdfRect.top) / pdfRect.height;

    const newSignaturePosition = {
      normalizedX,
      normalizedY,
      page: currentPage,
      scale: scale,
    };

    setSignaturePositions([...signaturePositions, newSignaturePosition]);
  };

  const handleRemoveSign = (index) => {
    const signature = signaturePositions.filter((_, i) => i !== index);
    setSignaturePositions(signature);
  };

  const handleMouseMove = (e) => {
    if (isSelectingPosition) {
      const container = containerRef.current;
      const pdfElement = container.querySelector(".react-pdf__Page");
      if (!pdfElement) return;

      const pdfRect = pdfElement.getBoundingClientRect();
      const scrollLeft = container.scrollLeft || 0;
      const scrollTop = container.scrollTop || 0;
      setCursorPosition({
        x: e.clientX + scrollLeft - pdfRect.left,
        y: e.clientY + scrollTop - pdfRect.top,
      });
    }
  };

  const resetState = () => {
    setPdfFile(null);
    setPdfUrl(null);
    setSignaturePositions([]);
  };

  return {
    pdfFile,
    pdfUrl,
    numPages,
    currentPage,
    scale,
    signaturePositions,
    isSelectingPosition,
    containerRef,
    setNumPages,
    setCurrentPage,
    setScale,
    setIsSelectingPosition,
    setPdfFile,
    setPdfUrl,
    setSignaturePositions,
    handlePdfClick,
    resetState,
    handleMouseMove,
    cursorPosition,
    handleRemoveSign,
  };
};

export default usePDFOperations;
